<template>
  <div style="height: auto;width: 100%;margin-top: 5px;" class="section cargo-advance-search query-bill-oversea-condition">
    <div v-show="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          class="el-icon-arrow-left"
          :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div v-show="showSimple" class="cargo-advance-search-quick">
        <div style="width: 100%">
          <div class="form-column">
            <el-form
              label-position="left"
              :inline="true"
              label-width="75px"
            >
              <el-form-item :label="$t('CargoMsg.Cargo_SettleAccountsTo')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{active:true}"
                  :default-value="filter.accountId"
                  @parentCallBack="p=>{filter.accountId=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_DateType')">
                <div style="display: flex">
                  <el-select v-model="filter.dateType" style="width: 200px" :allow-create="true">
                    <el-option
                      v-for="(item,index) in arDateOption"
                      :key="index"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                  <el-date-picker
                    v-model="filter.minDate"
                    type="date"
                    style="width:122px;"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="margin-right: 5px; margin-left: 5px;">{{ $t('Pricing.EndDate') }}</span>
                  <el-date-picker
                    v-model="filter.maxDate"
                    type="date"
                    style="width:122px;"
                    value-format="yyyy-MM-dd"
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="cargo-advance-search-more"
    >
      <el-form ref="hbDetail" label-width="75px" label-position="left" :inline="true" style="margin-left: 37px;">
        <el-form-item :label="$t('CargoMsg.Cargo_OurBank')">
          <el-select
            v-model="filter.ourBank"
          >
            <el-option
              v-for="(item,index) in bankAccounts"
              :key="index"
              :label="item.bankChineseName"
              :value="item.bankChineseName"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_WriteOffPerson')">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_User"
            :method-params="{ category: 'role', shape: 'acct' }"
            :default-value="filter.verificationBy"
            @parentCallBack="p=>{filter.verificationBy=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ReceiveMethod')">
          <el-select
            v-model="filter.type"
          >
            <el-option
              v-for="(item,index) in ClearingConstants.AMOUNT_RECEIVE_TYPE_LIST_OPTION"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label-width="90px" :label="$t('CargoMsg.Cargo_SendConfirmationStatus')">
          <el-select
            v-model="filter.confirmState"
          >
            <el-option
              v-for="(item,index) in sendStates"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form label-width="75px" label-position="left" :inline="true" style="margin-left: 37px;">
        <el-form-item :label="$t('CargoMsg.Cargo_Currency')">
          <el-select
            v-model="filter.currency"
          >
            <el-option
              v-for="(item,index) in ClearingConstants.CURRENCY_LIST_OPTION"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_VoucherNo')">
          <el-input v-model="filter.bankWaterNo" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_AmountRange')">
          <div style="display: flex">
            <el-input v-model="filter.amountMin" style="width: 84px;" />
            <span style="margin-right: 5px; margin-left: 5px;">{{ $t('CargoMsg.Cargo_To') }}</span>
            <el-input v-model="filter.amountMax" style="width: 84px;" />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div ref="searchOperations" class="cargo-advance-search-operations" style="margin-left: 27px;">
      <slot name="operations">
        <!--页面操作按钮-->
      </slot>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import StrUtils from '@/utils/StrUtils'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { getBankAccountList } from '@/api/bankAccount'

export default {
  name: 'QueryBillActualAmountCondition',
  components: {
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    billState: { type: Number, default: 0 },
    sourceSubmitState: { type: Number, default: 0 }
  },
  data() {
    return {
      URL,
      bankAccounts: [],
      filter: {
        dateType: this.$t('CargoMsg.Cargo_PayReceiveDate'),
        clearingState: '0',
        currency: 'ALL',
        jobState: this.$t('CargoMsg.Cargo_All'),
        accountId: 0,
        lob: []
      },
      selectTypeNames: TYPE_NAMES,
      ClearingConstants: ClearingConstants,
      voyageNos: [],
      arDateOption: [
        this.$t('CargoMsg.Cargo_PayReceiveDate'),
        this.$t('CargoMsg.Cargo_WriteOffDate')
      ],
      jobStates: [
        this.$t('CargoMsg.Cargo_All'),
        this.$t('CargoMsg.Cargo_Approved')
      ],
      sendStates: [{
        label: this.$t('CargoMsg.Cargo_All'),
        value: '-1'
      }, {
        label: this.$t('CargoMsg.Cargo_NotSent'),
        value: '0'
      }, {
        label: this.$t('CargoMsg.Cargo_Sent'),
        value: '1'
      }, {
        label: this.$t('CargoMsg.Cargo_BranchConfirmed'),
        value: '2'
      }],
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      option: {},
      showDetail: false
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    },
    'filter.allIn': function() {
      this.$emit('onGridRefresh')
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.filter.submitState = this.sourceSubmitState
      this.initBankAccounts()
    },
    getSearchOption() {
      const option = {}
      const filter = this.filter
      // 海外代理
      if (filter.accountId > 0) {
        option['accountId'] = filter.accountId
      }
      // 币种
      if (!StrUtils.isEmpty(filter.currency) && filter.currency !== 'ALL') {
        option['currency'] = filter.currency
      }
      // 凭证号
      if (!StrUtils.isEmpty(filter.bankWaterNo)) {
        option['bankWaterNo'] = filter.bankWaterNo
      }
      // 我方银行
      if (!StrUtils.isEmpty(filter.ourBank)) {
        option['ourBank'] = filter.ourBank
      }
      // 销账人
      if (!StrUtils.isEmpty(filter.verificationBy)) {
        option['verificationBy'] = filter.verificationBy
      }
      // 收款方式
      if (!StrUtils.isEmpty(filter.type) && filter.type !== 'ALL') {
        option['type'] = filter.type - 1
      }

      // 日期类型
      if (this.filter.minDate || this.filter.maxDate) {
        option['dateType'] = this.getDateOption(option)
        option['minDate'] = this.filter.minDate
        option['maxDate'] = this.filter.maxDate
      }

      // 金额区间
      if (!StrUtils.isEmpty(filter.amountMin)) { option['amountMin'] = filter.amountMin }
      if (!StrUtils.isEmpty(filter.amountMax)) { option['amountMax'] = filter.amountMax }
      option['confirmState'] = Number(filter.confirmState)

      return option
    },
    initBankAccounts() {
      getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
        const bankAccounts = []
        if (res.data && res.data.length > 0) {
          let item = {}
          item.bankChineseName = ''
          bankAccounts.push(item)
          for (const bank of res.data) {
            item = {}
            item.bankChineseName = bank.bankChineseName
            bankAccounts.push(item)
          }
        }
        this.bankAccounts = bankAccounts
      })
    },
    getDateOption() {
      const dateType = this.filter.dateType
      switch (dateType) {
        case this.$t('CargoMsg.Cargo_PayReceiveDate'):
          return 'actualAmount.PAY_RECEIVE_DATE'
        case this.$t('CargoMsg.Cargo_WriteOffDate'):
          return 'actualAmount.VERIFICATIONDATE'
      }
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter = {
        dateType: this.$t('CargoMsg.Cargo_BusinessDate'),
        billType: 'ALL',
        clearingState: '0',
        currency: 'ALL',
        jobState: this.$t('CargoMsg.Cargo_All'),
        submitState: this.sourceSubmitState
      }
    },
    changeCurrency(p) {
      this.filter.currency = p.value
      this.$emit('onGridRefresh')
    }
  }
}
</script>
<style lang="scss">
  .query-bill-oversea-condition{
    .cargo-advance-search-header{
      padding-bottom: 0px !important;
    }
    .el-input{
      width: 190px;
    }
    .el-form-item{
      margin-right: 30px;
      margin-bottom: 5px !important;
    }
  }
</style>
